<template>
  <div>
    <ContentWrapperControl>
      <div class="bg-white rounded-b-lg shadow overflow-hidden p-4 mb-4">
        <div
          v-text="lang('lbl_0000283')"
          class="text-sm leading-normal text-grey-darkest"
        ></div>
      </div>
      <div class="bg-white p-4 rounded-lg shadow overflow-hidden">
        <OTPControl
          @success="success"
          @failed="failed"
          @showloader="showLoader"
          @hideloader="hideLoader"
          v-bind:type="otp_type"
          v-bind:pin="otp_pin"
          v-bind:mobile="mobile_no"
          v-bind:email="email"
          v-bind:name="name"
        />
      </div>
    </ContentWrapperControl>
  </div>
</template>
<script>
import ContentWrapperControl from "./../components/controls/ContentWrapperControl.vue";
import OTPControl from "@/components/controls/OTPControl.vue";
import mixin from "./../mixin.js";
import OTP from "@/services/OTP";

export default {
  mixins: [mixin],
  components: {
    ContentWrapperControl,
    OTPControl,
  },
  mounted() {
    this.$emit("checkauth", false);
    this.$emit("shownavbar", {
      title: this.lang("lbl_0000282"),
      show: true,
      back: false,
    });
    this.$emit("nofooter", true);
    this.requestOTP();
  },
  data() {
    return {
      otp_type: 10,
      otp_pin: null,
      username: "",
      password: "",
      name: null,
      email: null,
      mobile_no: null,
    };
  },
  methods: {
    success() {
      let state = this.$store.state;
      state.otp_login = true;
      this.makeOTPLoginCookie(state.hash);
      this.$emit("login");
      this.$router.push("/dashboard");
    },
    failed(message) {
      this.$emit("alert", {
        theme: "error",
        title: this.lang("lbl_0000058"),
        message: message,
      });
    },
    showLoader() {
      this.$emit("showloader");
    },
    hideLoader() {
      this.$emit("hideloader");
    },
    requestOTP(type) {
      let state = this.$store.state;
      type = type ?? this.otp_type;

      if (
        state.login &&
        state.pin_login &&
        (!state.config.some(
          (item) => item.type === 2 && item.status === true
        ) ||
          state.otp_login)
      ) {
        return;
      }

      this.$emit("showloader");
      OTP.request(
        type,
        state.info.first_name,
        state.info.email,
        state.info.mobile_no
      )
        .then((response) => {
          this.otp_pin = response.data.data.pin;
        })
        .catch((error) => {
          this.$emit("failed", error.response.data.message);
        })
        .finally(() => {
          this.$emit("hideloader");
        });
    },
  },
};
</script>
<style></style>
